import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, collection, doc, getDoc, setDoc, updateDoc, query, where, getDocs, enableIndexedDbPersistence, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase configuration for LIVE project
const firebaseConfig = {
  apiKey: "AIzaSyC5u_QRNFxQ4kstgAzJ36JVqbiX0lU1-Lw",
  authDomain: "tee-time-finder-2025-9b689.firebaseapp.com",
  projectId: "tee-time-finder-2025-9b689",
  storageBucket: "tee-time-finder-2025-9b689.appspot.com",
  messagingSenderId: "149572739980",
  appId: "1:149572739980:web:d89dbab875cecbc499aca9",
  measurementId: "G-4JG7GEQSLZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Functions
export const functions = getFunctions(app);

// Connect to emulators in development. CRA pins NODE_ENV to 'development'
// under `npm start` and it cannot be overridden, so this is opt-out via
// REACT_APP_USE_EMULATORS=false - useful for previewing UI work against real
// production data. Default is unchanged: emulators on.
const useEmulators = process.env.NODE_ENV === 'development'
  && process.env.REACT_APP_USE_EMULATORS !== 'false';
if (useEmulators) {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(functions, 'localhost', 5002);
}

// Enable offline persistence for the default database
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
  } else if (err.code === 'unimplemented') {
    console.warn('The current browser does not support persistence.');
  }
});

// Initialize Storage
export const storage = getStorage(app);

// Helper function to check if a user has premium access
export const checkPremiumAccess = async (userId) => {
  try {
    const premiumDoc = await getDoc(doc(db, 'premiumUsers', userId));
    return premiumDoc.exists() && premiumDoc.data()?.subscriptionActive === true;
  } catch (error) {
    console.error('Error checking premium access:', error);
    return false;
  }
};

// Helper function to add a user to premium list
export const addPremiumUser = async (userId) => {
  try {
    await setDoc(doc(db, 'premiumUsers', userId), {
      timestamp: new Date(),
      status: 'active'
    });
  } catch (error) {
    console.error('Error adding premium user:', error);
    throw error;
  }
};

// Helper function to remove a user from premium list
export const removePremiumUser = async (userId) => {
  try {
    await setDoc(doc(db, 'premiumUsers', userId), {
      timestamp: new Date(),
      status: 'cancelled'
    });
  } catch (error) {
    console.error('Error removing premium user:', error);
    throw error;
  }
}; 